import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../setup";

export const managerOtpApi = createApi({
  reducerPath: "managerOtpApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    sendManagerOtp: builder.mutation({
      query: ({ email }) => ({
        url: `auth/manager/otp/send`,
        method: "POST",
        body: { email },
      }),
    }),
    verifyManagerOtp: builder.mutation({
      query: ({ start_token, otp }) => ({
        url: `auth/manager/otp/verify`,
        method: "POST",
        body: { start_token, otp },
      }),
    }),
    resendManagerOtp: builder.mutation({
      query: ({ start_token }) => ({
        url: `auth/manager/otp/resend`,
        method: "POST",
        body: { start_token },
      }),
    }),
  }),
});

export const {
  useSendManagerOtpMutation,
  useVerifyManagerOtpMutation,
  useResendManagerOtpMutation,
} = managerOtpApi;
